/** Goal id that reorders recommendations. Any other goal keeps fixture order. */
export const CAREER_CHANGE_GOAL_ID = 'career-change';

/**
 * Returns a new program list. Career change reverses relevance order.
 * Clearing the goal, or choosing any other goal, restores fixture order.
 * The result contains every input program once.
 */
export function rerankCareerPrograms<T>(
  programs: T[],
  goalChip: string | null,
): T[] {
  if (goalChip === CAREER_CHANGE_GOAL_ID) {
    return programs.slice().reverse();
  }

  return programs.slice();
}
